export default {
    wrappedLoadSave: (ViewModelService, ViewModelContext) => {
        return (action, model) => {
            return action.call(undefined, model)
                .then(submissionDTO =>
                    ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext));
        };
    }
};